import { Center, Loader, Stack, Text } from '@mantine/core'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/auth-context'
import { storage } from '@/lib/storage'

export function RequireAuth() {
  const { user, ready } = useAuth()
  const location = useLocation()

  if (!storage.accessToken()) {
    const from = `${location.pathname}${location.search}`
    return <Navigate to="/login" state={{ from }} replace />
  }

  if (!ready || !user) {
    return (
      <Center mih="100dvh" bg="var(--mantine-color-body)">
        <Stack align="center" gap="md">
          <Loader size="md" type="oval" />
          <Text size="sm" c="dimmed">
            Загрузка сессии…
          </Text>
        </Stack>
      </Center>
    )
  }

  return <Outlet />
}
